/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import WorkFlowStep from './work-flow-step';
import WorkFlowStepDetail from './work-flow-step-detail';
import WorkFlowStepUpdate from './work-flow-step-update';
import WorkFlowStepDeleteDialog from './work-flow-step-delete-dialog';

const WorkFlowStepRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<WorkFlowStep />} />
    <Route path="new" element={<WorkFlowStepUpdate />} />
    <Route path=":id">
      <Route index element={<WorkFlowStepDetail />} />
      <Route path="edit" element={<WorkFlowStepUpdate />} />
      <Route path="delete" element={<WorkFlowStepDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default WorkFlowStepRoutes;
